import React, {Fragment, useState} from 'react';
import {useDispatch} from "react-redux";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faExclamationTriangle} from "@fortawesome/free-solid-svg-icons";
import {facturaSerieFolioConstraints, facturaSerieFolioFormDefault} from "./FacturaSerieFolioForm";
import { setFacturasCliente } from '../../actions/busqueda/busquedaFacturaAction';
import useForm from "../../hooks/useForm";
import {requests} from "../../constants/config";
import {GENERICO_RFC, EXTRANJERO_RFC, EXITO, NO_DATA} from "../../constants/enviroment";
import axios from "../../axios";
import Spinner from "../../components/Spinner";

const BusquedaRFC = (props) => {
    const dispatch = useDispatch();
    const [buscando, setIsBuscando] = useState(false);
    const [error, setErrores] = useState('');

    const {
        handleFormChange,
        isFormValid,
        getValue
    } = useForm(facturaSerieFolioFormDefault, facturaSerieFolioConstraints);

    const setForm = async (event) => {
        handleFormChange(event);
    };

    const disabledButton = () => {
        console.log(isFormValid());
        return !isFormValid();
    };

    const meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
                    'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];

    const anio = new Date().getFullYear();

    const handleSubmit = (event) => {
        event.preventDefault();
        setIsBuscando(true);
        setErrores('');

        let rfc = getValue('rfc');
        if(rfc === GENERICO_RFC || rfc === EXTRANJERO_RFC) {
            setErrores('La búsqueda de las facturas relacionadas a este RFC no está permitida');
            setIsBuscando(false);
        } else {
            let data = {
                rfc: getValue('rfc').trim(),
                mes: parseInt(getValue('mes')),
                anio: anio
            }
            console.log(data);
            axios.post(requests.consultaFactura.obtenerDocumentos, data
            ).then(res => {
                console.log(res.data);
                let facturas = res.data;
                let codeMsg = res.data.mensaje.codigo;
                setIsBuscando(false);
                dispatch(setFacturasCliente(facturas));

                if (codeMsg === EXITO) {
                    props.nextStep();
                } else if(codeMsg === NO_DATA) {
                    setErrores("No se han encontrado facturas relacionadas al RFC ingresado.");
                } else {
                    setErrores('Ocurrió un error, valide los datos ingresados.');
                }
            }).catch((error) => {
                setIsBuscando(false);
                setErrores('Ocurrió un error favor de ponerse en contacto con el Servicio al Cliente.');
            });
        }
    };

    return (
        <Fragment>
            <h3>Ingrese la información para recuperar sus comprobantes fiscales.</h3>
            <p>Consulte los comprobantes del periodo trimestral vigente.</p>
            {/*<div className="mb-40">
                <a className="btn btn--large btn-info"
                    href="/">Preguntas frecuentes {' '} 
                        <FontAwesomeIcon className="feature-box__icon feature-box__icon--small"
                                        icon={faInfoCircle}/>
                </a>
            </div>*/}
           

            {(error !== null && error !== '') ?
                <div className="alert alert-warning" role="alert">
                    <FontAwesomeIcon 
                        className="feature-box__icon feature-box__icon--small"
                        icon={faExclamationTriangle}
                    /> 
                    {error}
                </div> : ''
            }

            <form onSubmit={handleSubmit}>
                <div className="form-row">
                    <div className="form-group col-xs-12 col-md-5">
                        <label htmlFor="rfc">RFC*:</label>
                        <input 
                            className="form-control" id="rfc" name="rfc"
                            type="text"
                            value={getValue('rfc') || ''}
                            onChange={setForm}
                            disabled={buscando}
                            placeholder="RFC"
                            maxLength="13"
                            autoComplete="off"  
                        />
                    </div>
                    <div className="form-group col-xs-12 col-md-4">
                        <label htmlFor="mes">Mes*:</label>
                        <select 
                            className="form-control" id="mes" name="mes"
                            value={getValue('mes') || '0'}
                            onChange={setForm}
                            disabled={buscando}
                        >
                            <option key={-1} value="0" disabled>Seleccionar mes</option>
                            {meses.map((mes, i) => (
                                <option key={i} value={i+1}>{mes}</option>
                            ))}
                        </select>
                    </div>
                    <div className="form-group col-xs-12 col-md-3">
                    <label htmlFor="anio">Año*:</label>
                        <input 
                            type="text"
                            className="form-control" 
                            id="anio" 
                            name="anio"
                            value={anio}
                            disabled
                        />
                    </div>
                </div>
                
                <button type="submit" className="btn btn-lg btn-chapur btn-block mt-30"
                        disabled={buscando || disabledButton()}>
                    {!buscando ? 'Buscar' : 'Buscando...'}
                    {buscando && <Spinner/>}
                </button>
            </form>
        </Fragment>
    );
};

export default BusquedaRFC;